import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-strategy',
  templateUrl: './data-strategy.component.html',
  styleUrls: ['./data-strategy.component.sass']
})
export class DataStrategyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
